import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModulePermissionComponent } from './module-permission.component';
import { EditModulePermissionComponent } from './edit-module-permission/edit-module-permission.component';
import { AddModulePermissionComponent } from './add-module-permission/add-module-permission.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ModulePermissionComponent,
    AddModulePermissionComponent,
    EditModulePermissionComponent,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
  exports: [ModulePermissionComponent],
})
export class ModulePermissionModule {}
